import { render, staticRenderFns } from "./SwitchControl.vue?vue&type=template&id=33b57f8a&scoped=true"
import script from "./SwitchControl.vue?vue&type=script&lang=js"
export * from "./SwitchControl.vue?vue&type=script&lang=js"
import style0 from "./SwitchControl.vue?vue&type=style&index=0&id=33b57f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b57f8a",
  null
  
)

export default component.exports